<template>
<loader v-bind="{ loading }">
  <div class="columns">
    <div class="column">
      <div class="is-flex justify-between">
        <h4 class="title is-marginless">
          <span class="has-text-secondary">{{ attribute.type.title }}</span><br>
          <span class="help">Last updated {{ attribute.updated_at | asCalendar }}</span>
        </h4>
        <attribute-status :attribute="attribute"/>
      </div>
      <p>{{ attribute.type.description }}</p>
      
      <div class="columns">
        <div class="column">
          <component :is="`display-${attribute.type.display_component}`" :attribute="attribute"/> 
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <h3 class="title is-5">Findings ({{ attribute.findings.length }})</h3>
          <findings-by-checkpoint
            :checkpoint-id="checkpointId"
            :findings="findings"
            v-for="(findings, checkpointId) in findingsByCheckpoint" :key="checkpointId"
          />
          <p v-if="!attribute.findings.length">No findings to display.</p>
        </div>
      </div>
    </div>
    <div class="column is-3">
      <div class="columns">
        <div class="column">
          <p class="is-size-6">Change Log ({{ attributeChanges.length }})</p>
          <div class="columns" v-for="audit in attributeChanges" :key="audit.id">
            <div class="column">
              <span class="help is-danger">{{ audit.created_at | asCalendar }}</span>
              <p>{{ audit.old || 'NULL' }} => {{ audit.new }}</p>
            </div>
          </div>
          <p v-if="!attributeChanges.length">No changes found.</p>
        </div>
      </div>
    </div>
  </div>
</loader>  
</template>
<script>
import { mapGetters } from 'vuex'
import AttributeStatus from '@/views/attribute/partials/Status'
import FindingsByCheckpoint from './partials/FindingsByCheckpoint.vue'

export default {

  components: {
    AttributeStatus,
    FindingsByCheckpoint
  },

  data: () => ({
    loading: true
  }),

  beforeCreate() {
    this.$store.dispatch('attribute/loadAttribute', this.$route.params.attribute)
      .then(() => this.loading = false)
  },
  
  computed: {
    ...mapGetters('attribute', [
      'attribute',
      'findingsByCheckpoint'
    ]),
    attributeChanges() {
      return this.attribute.changes.filter(change => change.old !== null)
    },
    
  }

}
</script>